import React from 'react';

const Ripple = React.forwardRef<HTMLSpanElement>((_props, ref) => {
  return <span ref={ref} className="mdc-list-item__ripple" />;
});

export default Ripple;
